import {
FETCH_EVENTS,
FETCH_EVENTS_FAILED,
FETCH_EVENTS_SUCCESSFUL,
FETCH_SINGLE_EVENTS,
FETCH_SINGLE_EVENTS_COMPLETE,
} from "./types";

export const initialState = {
  fetchingEvents: false,
  fetchingSingleEvent: false,
  events: {}
};

export const eventReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SINGLE_EVENTS: return ({
      ...state,
      fetchingSingleEvent: true
    });
    case FETCH_SINGLE_EVENTS_COMPLETE: return ({
      ...state,
      fetchingSingleEvent: false,
    })
    case FETCH_EVENTS: return ({
      ...state,
      fetchingEvents: true,
    });
    case FETCH_EVENTS_FAILED: return ({
      ...state,
      fetchingEvents: false,
    });
    case FETCH_EVENTS_SUCCESSFUL: return ({
      ...state,
      fetchingEvents: false,
      events: action?.events,
    })
  
    default:
      return state;
  }
};
